import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'
import type { BackupStorage } from './BackupStorage'

/** Имя файла снимка БД в нативном защищённом каталоге. */
export const BACKUP_FILE_NAME = 'pos_database_backup.json'

/**
 * Нативное хранилище бэкапов поверх @capacitor/filesystem.
 *
 * Снимок БД пишется в Directory.Documents (защищённый каталог приложения
 * iOS/Android), что обходит ограничения Safari iOS: удаление IndexedDB через
 * 7 дней бездействия и лимит ~50 МБ. Реализует тот же интерфейс BackupStorage,
 * что и WebBackupStorage, поэтому BackupService работает с ним без изменений.
 */
export class NativeBackupStorage implements BackupStorage {
  private readonly fileName: string
  private readonly directory: Directory

  constructor(fileName: string = BACKUP_FILE_NAME, directory: Directory = Directory.Documents) {
    this.fileName = fileName
    this.directory = directory
  }

  async save(json: string): Promise<void> {
    await Filesystem.writeFile({
      path: this.fileName,
      data: json,
      directory: this.directory,
      encoding: Encoding.UTF8,
    })
  }

  async load(): Promise<string | null> {
    try {
      const result = await Filesystem.readFile({
        path: this.fileName,
        directory: this.directory,
        encoding: Encoding.UTF8,
      })
      // В UTF8-режиме data приходит строкой; подстрахуемся на случай Blob.
      return typeof result.data === 'string' ? result.data : null
    } catch {
      // Файла ещё нет — это не ошибка (первый запуск).
      return null
    }
  }

  async has(): Promise<boolean> {
    try {
      await Filesystem.stat({ path: this.fileName, directory: this.directory })
      return true
    } catch {
      return false
    }
  }
}
